import { Link, useNavigate } from "react-router-dom";
import "@/styles/dashboard.css";
import { useDispatch, useSelector } from "react-redux";
import UserSection from "../header/UserSection";
import { AiChatBotShortLogo, InfoTooltipIcon } from "@/assets/AiBotAssets";
import { State } from "../../redux/Types";
import environment from "@/constants/Environment";
import { userSlice } from "@/redux/User";
import { TabTitle } from "@/utils/TitleFuntion";
import { useContext, useEffect, useMemo, useState } from "react";
import { addValue } from "@/redux/User";
import useFormatNumber from "@/hooks/UseFormatNumber";
import {
  ApiKeyIcon,
  MessageCountGreen,
  MessageCountRed,
} from "@/pages/cbb-builder/components/AiBotAssets";
import { BotContext } from "@/pages/cbb-builder/store";
import useStore from "@/pages/omni-builder/store";
import useGetCompany from "@/hooks/useGetCompany";
import { useUserDetails } from "@/react-query/useUserDetails";
import OpenAi from "../integration-modals/OpenAi";
import useOpenaiConfig from "@/pages/omni-builder/react-query/configs/useOpenaiConfig";
import SupportVideo from "./SupportVideo";
import NewCompanyOnboarding from "@/pages/cbb-builder/NewCompanyOnboarding/NewCompanyOnboarding";
import ModalWrapper from "@/pages/cbb-builder/components/ModalWrapper";
import SmallScreenModal from "@/pages/omni-builder/components/SmallScreenModal";
type routeType =
  | "/dashboard"
  | "/integration"
  | "/analytics"
  | "/chats"
  | "/audience"
  | "/settings";

function SideNav() {
  const add_class = useSelector((state: any) => state.user.addClass);
  const role = useSelector((state: any) => state.user.role);
  const plan = useSelector((state: any) => state.user.plan);
  const creditUsed = useSelector((state: any) => state.user.creditUsed);
  const [currentLimit, setCurrentLimit] = useState<number>(0);
  const [currentUsage, setCurrentUsage] = useState<number>(0);
  const setting = useSelector((state: any) => state.user.settings);
  const dispatch = useDispatch();
  const router = useNavigate();
  const { data: userDetails } = useUserDetails();
  const companyDetails = useGetCompany();
  const fromOutgrow = useSelector((state: State) => state.user.fromOutgrow);
  const isNewUser = useSelector((state: State) => state.user.isNewUser);
  const [openSupportVideo, setOpenSupportVideo] = useState(false);
  const [isSmallScreen, setIsSmallScreen] = useState(false);
  const [inBuilder, setInBuilder] = useState<boolean>(false);
  const openConfigModalId = useStore((state) => state.openConfigModalId);
  const setOpenConfigModalId = useStore((state) => state.setOpenConfigModalId);
  const [showConfigModal, setshowConfigModal] = useState(false);
  const setRoute = (routeInput: routeType = "/dashboard") => router(routeInput);
  const { data: configData, status: configStatus } = useOpenaiConfig();
  const showCredits = fromOutgrow || isNewUser;
  const showModelSelection = useMemo(() => {
    const totalMsgsConsumed =
      companyDetails?.data?.data.data?.ai_currentUsage.rateLimit;
    if (configStatus !== "success") return false;

    return userDetails?.appSumo &&
      // totalMsgsConsumed >= 250 &&
      !configData.length
      ? true
      : false;
  }, [userDetails, companyDetails, configData]);

  // useEffect(() => {
  //   if (plan) {
  //     const rateLimit =
  //       plan.ai_currentLimits?.rateLimit + plan.ai_addons?.rateLimit?.amount;
  //     setCurrentLimit((prev) => rateLimit ?? 0);
  //     setCurrentUsage((prev) => plan.ai_currentUsage?.rateLimit ?? 0);
  //     window.ChatbotBuilder?.setUserData({
  //       msg_limit: plan?.ai_currentLimits?.rateLimit,
  //       msg_usage: plan?.ai_currentUsage?.rateLimit,
  //     });
  //   }
  // }, [plan]);
  useEffect(() => {
    if (!plan) return;

    const limit = showCredits
      ? (plan.ai_currentLimits?.aiCredits || 0) +
        (plan.ai_addons?.aiCredits?.amount || 0)
      : (plan.ai_currentLimits?.rateLimit || 0) +
        (plan.ai_addons?.rateLimit?.amount || 0);

    const usage = showCredits
      ? creditUsed || 0
      : plan.ai_currentUsage?.rateLimit || 0;

    setCurrentLimit(companyDetails?.data?.data?.data?.byok ? limit * 5 : limit);
    setCurrentUsage(companyDetails?.data?.data?.data?.byok ? usage * 5 : usage);

    // Keep external integration consistent
    window.ChatbotBuilder?.setUserData({
      msg_limit: limit,
      msg_usage: usage,
    });
  }, [plan, showCredits, companyDetails, creditUsed]);
  const remainingCount = Math.max(currentLimit - currentUsage, 0);
  const remainingUnit = showCredits ? "credits" : "messages";
  const addvalue = () => {
    dispatch(addValue(add_class ? "" : "app-collapse"));
    if (add_class) {
      dispatch(addValue(""));
      if (window.innerWidth <= 768) {
        document.body.style.overflow = "hidden";
      }
    } else {
      setIsSmallScreen(false);
      dispatch(addValue("app-collapse"));
      if (window.innerWidth <= 768) {
        document.body.style.overflow = "auto";
      }
    }
  };

  const handleContactsClick = () => {
    if (window.innerWidth <= 768) {
      setIsSmallScreen(true);
    } else {
      router("/contacts");
    }
  };

  useEffect(() => {
    if (
      (window.screen.width < 1279 ||
        window.location.pathname.includes("/builder")) &&
      !document.querySelector(".main-app")?.classList.contains("app-collapse")
    ) {
      addvalue();
    } else if (
      window.screen.width < 768 &&
      window.location.pathname.includes("/dashboard")
    ) {
      setIsSmallScreen(false);
    }
  }, []);

  useEffect(() => {
    if (window.location.pathname.includes("/builder")) setInBuilder(true);
    else setInBuilder(false);
    if (
      window.location.pathname.includes("/builder") &&
      !document.querySelector(".main-app")?.classList.contains("app-collapse")
    ) {
      addvalue();
    }
  }, [setRoute]);

  return (
    <>
      <div className="left-col sn">
        <div className="closing-modal">
          <button onClick={addvalue}>
            <svg
              width="15"
              height="15"
              viewBox="0 0 10 10"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M10 1.00714L8.99286 0L5 3.99286L1.00714 0L0 1.00714L3.99286 5L0 8.99286L1.00714 10L5 6.00714L8.99286 10L10 8.99286L6.00714 5L10 1.00714Z"
                fill="#6D6D6D"
              ></path>
            </svg>
          </button>
        </div>
        <div className="sidebar sn">
          <div
            onClick={addvalue}
            className={`line_icon ${
              window.location.pathname.includes("/builder") ? "none" : ""
            }`}
          >
            <svg
              className="wb-svg"
              width="10"
              height="10"
              viewBox="0 0 10 10"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M1.175 2.08337L5 5.94961L8.825 2.08337L10 3.27947L5 8.33337L0 3.27947L1.175 2.08337Z"
                fill="#666666"
              ></path>
            </svg>

            <svg
              className="fn-svg"
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M17.467 19C17.467 18.8011 17.388 18.6103 17.2474 18.4697C17.1067 18.329 16.916 18.25 16.717 18.25H4.00004C3.80113 18.25 3.61036 18.329 3.46971 18.4697C3.32906 18.6103 3.25004 18.8011 3.25004 19C3.25004 19.1989 3.32906 19.3897 3.46971 19.5303C3.61036 19.671 3.80113 19.75 4.00004 19.75H16.717C16.916 19.75 17.1067 19.671 17.2474 19.5303C17.388 19.3897 17.467 19.1989 17.467 19ZM11.778 5C11.778 4.80109 11.699 4.61032 11.5584 4.46967C11.4177 4.32902 11.227 4.25 11.028 4.25H4.00004C3.80113 4.25 3.61036 4.32902 3.46971 4.46967C3.32906 4.61032 3.25004 4.80109 3.25004 5C3.25004 5.19891 3.32906 5.38968 3.46971 5.53033C3.61036 5.67098 3.80113 5.75 4.00004 5.75H11.028C11.227 5.75 11.4177 5.67098 11.5584 5.53033C11.699 5.38968 11.778 5.19891 11.778 5Z"
                fill="#444444"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M20.75 12C20.75 11.8011 20.671 11.6103 20.5303 11.4697C20.3897 11.329 20.1989 11.25 20 11.25H4C3.80109 11.25 3.61032 11.329 3.46967 11.4697C3.32902 11.6103 3.25 11.8011 3.25 12C3.25 12.1989 3.32902 12.3897 3.46967 12.5303C3.61032 12.671 3.80109 12.75 4 12.75H20C20.1989 12.75 20.3897 12.671 20.5303 12.5303C20.671 12.3897 20.75 12.1989 20.75 12Z"
                fill="#444444"
                fillOpacity="0.5"
              />
            </svg>
          </div>
          <Link to="/dashboard">
            <div
              className="nav-logo flex-cnt"
              style={{ gap: environment().isAI ? "8px" : "2px" }}
            >
              {environment().isAI ? (
                <div className="logo-cbb">
                  <AiChatBotShortLogo />
                </div>
              ) : (
                <div className="logo-og">
                  <OmniengageLogo />
                </div>
              )}
              {environment().isAI ? (
                <h1 className="nav-logo-chatbotbuilder">ChatBot Builder</h1>
              ) : (
                <h1>Omniengage</h1>
              )}
            </div>
          </Link>
          <div className="links">
            <ul>
              <li
                onClick={window.innerWidth <= 768 ? addvalue : undefined}
                className={
                  window.location.pathname === "/dashboard"
                    ? "home side-active"
                    : "home"
                }
              >
                <Link to="/dashboard">
                  <HomeIcon />
                  <span>Dashboard</span>
                </Link>
                {!!add_class && (
                  <p className="sm-tooltip flex-cnt">
                    <span className="sm-tooltip_text">Dashboard</span>
                  </p>
                )}
              </li>
              <li
                onClick={window.innerWidth <= 768 ? addvalue : undefined}
                className={
                  window.location.pathname === "/integration"
                    ? "integration side-active"
                    : "integration"
                }
              >
                <Link to="/integration">
                  <IntegrationIcon />
                  <span>Integrations</span>
                </Link>
                {!!add_class && (
                  <p className="sm-tooltip flex-cnt">
                    <span className="sm-tooltip_text">Integrations</span>
                  </p>
                )}
              </li>
              {!environment().isAI && (
                <li
                  className={
                    window.location.pathname === "/templates"
                      ? "templates side-active"
                      : "templates"
                  }
                >
                  <Link to="/templates">
                    <TemplatesIcon />
                    <span>Templates</span>
                  </Link>
                  {!!add_class && (
                    <p className="sm-tooltip flex-cnt">
                      <span className="sm-tooltip_text">Templates</span>
                    </p>
                  )}
                </li>
              )}
              <li
                onClick={window.innerWidth <= 768 ? addvalue : undefined}
                className={
                  window.location.pathname === "/analytics"
                    ? "side-active side-active-analysis"
                    : "analysis"
                }
              >
                <Link to="/analytics">
                  <AnalyticsIcon />

                  <span>Analytics</span>
                </Link>
                {!!add_class && (
                  <p className="sm-tooltip flex-cnt">
                    <span className="sm-tooltip_text">Analytics</span>
                  </p>
                )}
              </li>

              {environment().isAI ? (
                <li
                  className={`chats ${window.location.pathname.includes("/contacts") ? "side-active" : ""}`}
                >
                  {plan?.name === "Free" ? (
                    <>
                      <Link to={""} className="locked-chat">
                        <ChatsIcon />
                        <span>Chats</span>
                        <div className="lock-icon">
                          <LockSvg />
                        </div>
                      </Link>
                      <div className="new-config-tooltip fx fx-d-col gap-8">
                        <p>
                          Your plan does not include this feature. Buy one of
                          our plans to <span>unlock </span>
                          this feature.
                        </p>
                        <a
                          onClick={() => {
                            router("/settings");
                            dispatch(userSlice.actions.setSettings(2));
                          }}
                        >
                          Upgrade Plan
                        </a>
                      </div>
                    </>
                  ) : (
                    <>
                      <button
                        onClick={handleContactsClick}
                        className="contacts-btn"
                      >
                        <ChatsIcon />
                        <span>Contacts</span>
                      </button>
                      {!!add_class && (
                        <p className="sm-tooltip flex-cnt">
                          <span className="sm-tooltip_text">Contacts</span>
                        </p>
                      )}
                    </>
                  )}
                </li>
              ) : (
                <li
                  className={
                    window.location.pathname === "/chats"
                      ? `chats side-active`
                      : `chats`
                  }
                >
                  <Link to="/chats">
                    <ChatsIcon />
                    <span>Chats</span>
                  </Link>
                  {!!add_class && (
                    <p className="sm-tooltip flex-cnt">
                      <span className="sm-tooltip_text">Chats</span>
                    </p>
                  )}
                </li>
              )}
              {!environment().isAI && (
                <li
                  className={
                    window.location.pathname === "/audience"
                      ? "audience side-active"
                      : "audience"
                  }
                  onClick={window.innerWidth <= 768 ? addvalue : undefined}
                >
                  <Link to="/audience">
                    <AudienceIcon />
                    <span>Audience</span>
                  </Link>
                  {!!add_class && (
                    <p className="sm-tooltip flex-cnt">
                      <span className="sm-tooltip_text">Audience</span>
                    </p>
                  )}
                </li>
              )}
            </ul>
          </div>
        </div>
        <div className="bottom_menu">
          <div className="links">
            {/* <span>Insights</span> */}
            <ul>
              {!showModelSelection ? (
                <li
                  className={`msg-limit-wrapper relative !w-[100%] rounded-[10px] border border-[rgba(0,0,0,0.10)] shadow-[0px_2px_8px_rgba(0,0,0,0.06)] ${currentUsage >= currentLimit ? "limit_exceeded" : ""}`}
                >
                  <div className="big-msg-count flex flex-col">
                    <div className="mb-[10px] flex items-center gap-[10px]">
                      {currentUsage >= currentLimit ? (
                        <MessageCountRed />
                      ) : (
                        <MessageCountGreen />
                      )}
                      <div className="flex flex-col items-start gap-[3px]">
                        <h4 className="text-[13px] font-medium leading-[110%] text-[#666]">
                          {showCredits ? "Credits" : "Messages"}
                        </h4>
                        <span className="text-[12px] leading-[110%] text-[#666]">
                          {`Unlock more ${showCredits ? "credits" : "messages"}`}
                        </span>
                      </div>
                    </div>
                    <div className="msg-count-bar mb-[5px] h-[6px] w-full rounded-[10px] bg-[#D5D5D5]">
                      <div
                        className={`h-full rounded-[10px] ${currentUsage >= currentLimit ? "bg-[#FB5F66]" : "bg-[#6DC870]"}`}
                        style={{
                          width: `${currentLimit ? Math.min((currentUsage / currentLimit) * 100, 100) : 0}%`,
                          ...(currentUsage > 0 ? { minWidth: "6px" } : {}),
                        }}
                      ></div>
                    </div>
                    <p className="mb-[10px] text-start text-[11px] leading-[100%] text-[#444]">
                      <span className="text-[11px] font-semibold">
                        {useFormatNumber(
                          showCredits ? remainingCount : currentUsage,
                        )}
                      </span>{" "}
                      {showCredits
                        ? `${remainingUnit} remaining`
                        : `of ${useFormatNumber(currentLimit)} used`}
                    </p>
                    <button
                      className="rounded-[8px] bg-[#FB5F66] px-[12px] py-[8px] text-[12px] font-normal leading-normal text-white hover:opacity-85"
                      onClick={() => {
                        setRoute("/settings");
                        dispatch(userSlice.actions.setSettings(2));
                      }}
                    >
                      Buy Now
                    </button>
                  </div>

                  <div className="small-msg-count flex flex-col items-center">
                    {currentUsage >= currentLimit ? (
                      <MessageCountRed />
                    ) : (
                      <MessageCountGreen />
                    )}
                    <h6 className="mb-[5px] mt-[8px] text-[11px] font-medium leading-[110%] text-[#666]">
                      {showCredits ? "Credits" : "Messages"}
                    </h6>
                    <p className="text-[11px] leading-[100%] text-[#444]">
                      <span className="!inline text-[13px] font-semibold">
                        {useFormatNumber(
                          showCredits ? remainingCount : currentUsage,
                        )}
                      </span>
                      {showCredits
                        ? ` ${remainingUnit} left`
                        : `/${useFormatNumber(currentLimit)}`}
                    </p>
                  </div>

                  <div className="msg-count-tooltip message-only none absolute z-[10] w-[182px] rounded-[10px] bg-[#222] p-[15px]">
                    <div className="relative flex flex-col">
                      <h5 className="mb-[1px] flex items-center gap-[4px] text-[12px] font-semibold leading-[100%] text-white">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="13"
                          height="13"
                          viewBox="0 0 13 13"
                          fill="none"
                        >
                          <path
                            d="M6.5 0C5.21442 0 3.95772 0.381218 2.8888 1.09545C1.81988 1.80968 0.986756 2.82484 0.494786 4.01256C0.00281636 5.20028 -0.125905 6.50721 0.124899 7.76809C0.375703 9.02896 0.994768 10.1872 1.90381 11.0962C2.81285 12.0052 3.97104 12.6243 5.23192 12.8751C6.49279 13.1259 7.79973 12.9972 8.98745 12.5052C10.1752 12.0132 11.1903 11.1801 11.9046 10.1112C12.6188 9.04229 13 7.78558 13 6.5C12.9981 4.77667 12.3127 3.12445 11.0941 1.90586C9.87556 0.687282 8.22334 0.00186392 6.5 0ZM6.5 11.9167C5.42869 11.9167 4.38143 11.599 3.49066 11.0038C2.5999 10.4086 1.90563 9.56264 1.49566 8.57287C1.08568 7.5831 0.978413 6.49399 1.18742 5.44326C1.39642 4.39253 1.91231 3.42737 2.66984 2.66984C3.42738 1.9123 4.39253 1.39642 5.44326 1.18741C6.49399 0.97841 7.58311 1.08568 8.57287 1.49565C9.56264 1.90563 10.4086 2.5999 11.0038 3.49066C11.599 4.38143 11.9167 5.42869 11.9167 6.5C11.9151 7.93611 11.3439 9.31294 10.3284 10.3284C9.31294 11.3439 7.93611 11.9151 6.5 11.9167Z"
                            fill="white"
                          />
                          <path
                            d="M6.49935 5.41699H5.95768C5.81402 5.41699 5.67625 5.47406 5.57467 5.57564C5.47308 5.67722 5.41602 5.815 5.41602 5.95866C5.41602 6.10232 5.47308 6.24009 5.57467 6.34167C5.67625 6.44326 5.81402 6.50033 5.95768 6.50033H6.49935V9.75033C6.49935 9.89398 6.55642 10.0318 6.658 10.1333C6.75958 10.2349 6.89736 10.292 7.04102 10.292C7.18467 10.292 7.32245 10.2349 7.42403 10.1333C7.52561 10.0318 7.58268 9.89398 7.58268 9.75033V6.50033C7.58268 6.21301 7.46855 5.93746 7.26538 5.73429C7.06222 5.53113 6.78667 5.41699 6.49935 5.41699Z"
                            fill="white"
                          />
                          <path
                            d="M6.5 4.33301C6.94873 4.33301 7.3125 3.96924 7.3125 3.52051C7.3125 3.07178 6.94873 2.70801 6.5 2.70801C6.05127 2.70801 5.6875 3.07178 5.6875 3.52051C5.6875 3.96924 6.05127 4.33301 6.5 4.33301Z"
                            fill="white"
                          />
                        </svg>
                        {`Unlock more ${showCredits ? "credits" : "messages"}`}
                      </h5>
                      <div className="msg-count-bar none mb-[5px] mt-[8px] h-[6px] w-full rounded-[10px] bg-[#EFEFEF]">
                        <div
                          className={`h-full rounded-[10px] ${currentUsage >= currentLimit ? "bg-[#FB5F66]" : "bg-[#6DC870]"}`}
                          style={{
                            width: `${currentLimit ? Math.min((currentUsage / currentLimit) * 100, 100) : 0}%`,
                            ...(currentUsage > 0 ? { minWidth: "6px" } : {}),
                          }}
                        ></div>
                      </div>
                      <p className="msg-count-number none mb-[8px] items-center gap-[2px] text-start text-[11px] leading-[110%] text-white">
                        <span className="!inline text-[11px] font-semibold">
                          {useFormatNumber(
                            showCredits ? remainingCount : currentUsage,
                          )}
                        </span>{" "}
                        {showCredits
                          ? `${remainingUnit} remaining`
                          : `of ${useFormatNumber(currentLimit)} used`}
                      </p>
                      <button
                        className="msg-count-button none w-100 h-[30px] items-center !justify-center rounded-[8px] bg-[#fb5f66] text-[12px] font-normal text-white hover:opacity-85"
                        onClick={() => {
                          setRoute("/settings");
                          dispatch(userSlice.actions.setSettings(2));
                        }}
                      >
                        Buy Now
                      </button>
                      <svg
                        className="msg-count-tooltip-arrow absolute left-[-22px]"
                        xmlns="http://www.w3.org/2000/svg"
                        width="12"
                        height="19"
                        viewBox="0 0 12 19"
                        fill="none"
                      >
                        <path
                          d="M0.693383 8.00201L8.67485 0.941477C9.9657 -0.200426 12 0.716035 12 2.43947V16.5605C12 18.284 9.9657 19.2004 8.67485 18.0585L0.693383 10.998C-0.206419 10.202 -0.20642 8.79799 0.693383 8.00201Z"
                          fill="#222222"
                        />
                      </svg>
                    </div>
                  </div>
                </li>
              ) : (
                <li
                  className={`msg-limit-wrapper relative !w-[100%] rounded-[10px] border border-[rgba(0,0,0,0.10)] !bg-[radial-gradient(56.98%_56.98%_at_50.53%_43.02%,_#C8E5FF_0%,_#FFF_100%)] shadow-[0px_2px_8px_rgba(0,0,0,0.06)]`}
                >
                  <div className="big-msg-count flex flex-col">
                    <h6 className="mb-[10px] flex items-center gap-[10px] text-[13px] font-medium leading-[110%] text-[#666]">
                      <ApiKeyIcon />
                      Add API Key
                    </h6>
                    <button
                      // onClick={() => setOpenConfigModalId("openai")}
                      onClick={() => setshowConfigModal(true)}
                      className="flex items-center !justify-center gap-[5px] rounded-[8px] bg-[#FB5F66] px-[12px] py-[8px] text-[12px] font-normal leading-normal text-white hover:opacity-85"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="12"
                        height="12"
                        viewBox="0 0 12 12"
                        fill="none"
                      >
                        <path
                          d="M6 0C4.81331 0 3.65328 0.351894 2.66658 1.01118C1.67989 1.67047 0.910851 2.60754 0.456725 3.7039C0.00259972 4.80026 -0.11622 6.00666 0.115291 7.17054C0.346802 8.33443 0.918247 9.40353 1.75736 10.2426C2.59648 11.0818 3.66557 11.6532 4.82946 11.8847C5.99335 12.1162 7.19975 11.9974 8.2961 11.5433C9.39246 11.0892 10.3295 10.3201 10.9888 9.33342C11.6481 8.34673 12 7.18669 12 6C11.9983 4.40923 11.3656 2.88411 10.2407 1.75926C9.1159 0.634414 7.59077 0.00172054 6 0ZM8 6.5H6.5V8C6.5 8.13261 6.44732 8.25979 6.35356 8.35355C6.25979 8.44732 6.13261 8.5 6 8.5C5.86739 8.5 5.74022 8.44732 5.64645 8.35355C5.55268 8.25979 5.5 8.13261 5.5 8V6.5H4C3.86739 6.5 3.74022 6.44732 3.64645 6.35355C3.55268 6.25979 3.5 6.13261 3.5 6C3.5 5.86739 3.55268 5.74021 3.64645 5.64645C3.74022 5.55268 3.86739 5.5 4 5.5H5.5V4C5.5 3.86739 5.55268 3.74021 5.64645 3.64645C5.74022 3.55268 5.86739 3.5 6 3.5C6.13261 3.5 6.25979 3.55268 6.35356 3.64645C6.44732 3.74021 6.5 3.86739 6.5 4V5.5H8C8.13261 5.5 8.25979 5.55268 8.35356 5.64645C8.44732 5.74021 8.5 5.86739 8.5 6C8.5 6.13261 8.44732 6.25979 8.35356 6.35355C8.25979 6.44732 8.13261 6.5 8 6.5Z"
                          fill="white"
                        />
                      </svg>
                      Add API Key
                    </button>
                  </div>

                  <div className="small-msg-count flex flex-col items-center">
                    <ApiKeyIcon />
                    <h6 className="mt-[8px] text-[11px] font-medium leading-[110%] text-[#666]">
                      Add
                    </h6>
                    <h6 className="text-[11px] font-medium leading-[110%] text-[#666]">
                      API Key
                    </h6>
                  </div>

                  {showModelSelection && (
                    <div
                      className={`msg-count-tooltip none absolute z-[10] w-[270px] rounded-[10px] bg-[#222] p-[15px] ${showModelSelection ? "!right-[-280px]" : ""}`}
                    >
                      <div className="relative flex flex-col">
                        <h5 className="mb-[4px] flex !items-center gap-[4px] text-[11px] font-semibold !leading-[100%] text-white">
                          {/* <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="13"
                          height="13"
                          viewBox="0 0 13 13"
                          fill="none"
                        >
                          <path
                            d="M6.5 0C5.21442 0 3.95772 0.381218 2.8888 1.09545C1.81988 1.80968 0.986756 2.82484 0.494786 4.01256C0.00281636 5.20028 -0.125905 6.50721 0.124899 7.76809C0.375703 9.02896 0.994768 10.1872 1.90381 11.0962C2.81285 12.0052 3.97104 12.6243 5.23192 12.8751C6.49279 13.1259 7.79973 12.9972 8.98745 12.5052C10.1752 12.0132 11.1903 11.1801 11.9046 10.1112C12.6188 9.04229 13 7.78558 13 6.5C12.9981 4.77667 12.3127 3.12445 11.0941 1.90586C9.87556 0.687282 8.22334 0.00186392 6.5 0ZM6.5 11.9167C5.42869 11.9167 4.38143 11.599 3.49066 11.0038C2.5999 10.4086 1.90563 9.56264 1.49566 8.57287C1.08568 7.5831 0.978413 6.49399 1.18742 5.44326C1.39642 4.39253 1.91231 3.42737 2.66984 2.66984C3.42738 1.9123 4.39253 1.39642 5.44326 1.18741C6.49399 0.97841 7.58311 1.08568 8.57287 1.49565C9.56264 1.90563 10.4086 2.5999 11.0038 3.49066C11.599 4.38143 11.9167 5.42869 11.9167 6.5C11.9151 7.93611 11.3439 9.31294 10.3284 10.3284C9.31294 11.3439 7.93611 11.9151 6.5 11.9167Z"
                            fill="white"
                          />
                          <path
                            d="M6.49935 5.41699H5.95768C5.81402 5.41699 5.67625 5.47406 5.57467 5.57564C5.47308 5.67722 5.41602 5.815 5.41602 5.95866C5.41602 6.10232 5.47308 6.24009 5.57467 6.34167C5.67625 6.44326 5.81402 6.50033 5.95768 6.50033H6.49935V9.75033C6.49935 9.89398 6.55642 10.0318 6.658 10.1333C6.75958 10.2349 6.89736 10.292 7.04102 10.292C7.18467 10.292 7.32245 10.2349 7.42403 10.1333C7.52561 10.0318 7.58268 9.89398 7.58268 9.75033V6.50033C7.58268 6.21301 7.46855 5.93746 7.26538 5.73429C7.06222 5.53113 6.78667 5.41699 6.49935 5.41699Z"
                            fill="white"
                          />
                          <path
                            d="M6.5 4.33301C6.94873 4.33301 7.3125 3.96924 7.3125 3.52051C7.3125 3.07178 6.94873 2.70801 6.5 2.70801C6.05127 2.70801 5.6875 3.07178 5.6875 3.52051C5.6875 3.96924 6.05127 4.33301 6.5 4.33301Z"
                            fill="white"
                          />
                        </svg> */}
                          Unlock More Messages with Your API Key
                        </h5>
                        <p className="text-start text-[11px] leading-[135%] text-white">
                          Add your API key to continue using the assistant
                          {/* without message limits. Connecting a key gives you
                        extended access when the limit is reached. */}
                        </p>
                        <button
                          className="msg-count-button none w-100 mt-[15px] h-[30px] items-center !justify-center gap-[5px] rounded-[8px] bg-[#fb5f66] text-[12px] font-normal text-white"
                          onClick={() => setshowConfigModal(true)}
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="13"
                            height="12"
                            viewBox="0 0 13 12"
                            fill="none"
                          >
                            <g clipPath="url(#clip0_8991_45234)">
                              <path
                                d="M6.5 0C5.31331 0 4.15328 0.351894 3.16658 1.01118C2.17989 1.67047 1.41085 2.60754 0.956725 3.7039C0.5026 4.80026 0.38378 6.00666 0.615291 7.17054C0.846802 8.33443 1.41825 9.40353 2.25736 10.2426C3.09648 11.0818 4.16557 11.6532 5.32946 11.8847C6.49335 12.1162 7.69975 11.9974 8.7961 11.5433C9.89246 11.0892 10.8295 10.3201 11.4888 9.33342C12.1481 8.34673 12.5 7.18669 12.5 6C12.4983 4.40923 11.8656 2.88411 10.7407 1.75926C9.6159 0.634414 8.09077 0.00172054 6.5 0ZM8.5 6.5H7V8C7 8.13261 6.94732 8.25979 6.85356 8.35355C6.75979 8.44732 6.63261 8.5 6.5 8.5C6.36739 8.5 6.24022 8.44732 6.14645 8.35355C6.05268 8.25979 6 8.13261 6 8V6.5H4.5C4.36739 6.5 4.24022 6.44732 4.14645 6.35355C4.05268 6.25979 4 6.13261 4 6C4 5.86739 4.05268 5.74021 4.14645 5.64645C4.24022 5.55268 4.36739 5.5 4.5 5.5H6V4C6 3.86739 6.05268 3.74021 6.14645 3.64645C6.24022 3.55268 6.36739 3.5 6.5 3.5C6.63261 3.5 6.75979 3.55268 6.85356 3.64645C6.94732 3.74021 7 3.86739 7 4V5.5H8.5C8.63261 5.5 8.75979 5.55268 8.85356 5.64645C8.94732 5.74021 9 5.86739 9 6C9 6.13261 8.94732 6.25979 8.85356 6.35355C8.75979 6.44732 8.63261 6.5 8.5 6.5Z"
                                fill="white"
                              />
                            </g>
                            <defs>
                              <clipPath id="clip0_8991_45234">
                                <rect
                                  width="12"
                                  height="12"
                                  fill="white"
                                  transform="translate(0.5)"
                                />
                              </clipPath>
                            </defs>
                          </svg>
                          Add API Key
                        </button>
                        <svg
                          className="msg-count-tooltip-arrow absolute left-[-22px]"
                          xmlns="http://www.w3.org/2000/svg"
                          width="12"
                          height="19"
                          viewBox="0 0 12 19"
                          fill="none"
                        >
                          <path
                            d="M0.693383 8.00201L8.67485 0.941477C9.9657 -0.200426 12 0.716035 12 2.43947V16.5605C12 18.284 9.9657 19.2004 8.67485 18.0585L0.693383 10.998C-0.206419 10.202 -0.20642 8.79799 0.693383 8.00201Z"
                            fill="#222222"
                          />
                        </svg>
                      </div>
                    </div>
                  )}
                </li>
              )}

              <li
                className={
                  window.location.pathname === "/settings" && setting !== 2
                    ? "settings side-active"
                    : "setings"
                }
                onClick={() => {
                  if (window.innerWidth <= 768) {
                    addvalue();
                  }
                  setRoute("/settings");
                  dispatch(userSlice.actions.setSettings(0));
                  TabTitle(`Omniengage | Settings`);
                }}
              >
                <Link to="/settings">
                  <SettingsIcon />
                  <span>Settings</span>
                </Link>
                {!!add_class && (
                  <p className="sm-tooltip flex-cnt">
                    <span className="sm-tooltip_text">Settings</span>
                  </p>
                )}
              </li>
              {role === "admin" && (
                <li
                  className={
                    (window.location.pathname === "/settings" ||
                      window.location.pathname === "/plan_expired" ||
                      window.location.pathname === "/trial_expired") &&
                    setting === 2
                      ? "pricing side-active pricing-icon"
                      : "pricing pricing-icon"
                  }
                  onClick={() => {
                    if (window.innerWidth <= 768) {
                      addvalue();
                    }
                    setRoute("/settings");
                    dispatch(userSlice.actions.setSettings(2));
                  }}
                >
                  <Link to="/settings">
                    <PricingIcon />
                    <span>Pricing</span>
                  </Link>
                  {!!add_class && (
                    <p className="sm-tooltip flex-cnt">
                      <span className="sm-tooltip_text">Pricing</span>
                    </p>
                  )}
                </li>
              )}
              <li
                className="support-icon outer-sidebar-support-icon relative"
                onClick={window.innerWidth <= 768 ? addvalue : undefined}
              >
                <a href="http://support.chatbotbuilder.net/">
                  {" "}
                  <SupportIcon /> <span>Support</span>
                </a>
                {/* <Link to="https://support.chatbotbuilder.net/" onClick={(e) => e.preventDefault()}>
                <SupportIcon />
                <span>Support</span>
              </Link> */}
                {/* <div className={`support-doc-tooltip none absolute right-[-270px] top-[-213px] rounded-[10px] bg-[#222] p-[15px] w-[260px]`}>
                <div className="support-doc-tooltip-body relative flex flex-col items-start">
                  <h3 className="text-white text-[14px] font-medium leading-[110%] mb-[4px]">Quick help: </h3>
                  <p className="text-white text-[12px] font-normal leading-[110%] opacity-50">Docs and Video walkthrough</p>
                  <div className="horizontal-bar h-[1px] w-100 bg-white opacity-20  mt-[10px] mb-[10px]"></div>
                  <h6 className="text-white text-[12px] font-normal leading-[150%] mb-[3px]">Support Document</h6>
                  <div className="flex justify-between items-center gap-[10px] rounded-[6px] bg-[#343434] px-[11px] py-[8px] w-100 mb-[10px]">
                    <span className="support-doc-link text-white text-[12px] font-medium leading-[150%] max-w-[170px]">
                      https://support.chatbotbuilder.net/
                    </span>
                    <img onClick={() => window.open("https://support.chatbotbuilder.net/", "_blank")} className="cursor-pointer" src="https://dlvkyia8i4zmz.cloudfront.net/xsnN5mPjTT1tFYcaqpbw_Frame__3_.svg" alt="" />
                  </div>
                  <h6 className="text-white text-[12px] font-normal leading-[150%] mb-[7px]">Video</h6>
                  <img onClick={()=>{setOpenSupportVideo(true)}} className="cursor-pointer" src="https://dlvkyia8i4zmz.cloudfront.net/mzUJXMEuRzSyQqP7CuUL_Group_1618874914__1_.svg" alt="" />
                  <img className="support-doc-tooltip-arrow absolute bottom-[20px] left-[-23px]" src="https://dlvkyia8i4zmz.cloudfront.net/Y0K35v6gRruxqf02dI76_Vector_1208.svg" alt="" />
                </div>
              </div> */}
              </li>
            </ul>
          </div>
          <UserSection setRoute={setRoute} />
        </div>

        {/* {openConfigModalId === "openai" && (
        <OpenAi onClose={() => setOpenConfigModalId("")} />
      )} */}
        {isSmallScreen && <SmallScreenModal />}
        {showConfigModal && (
          <NewCompanyOnboarding
            showModelSelection={true}
            onClose={() => {
              setshowConfigModal(false);
            }}
            showConfigModal={showConfigModal}
            setshowConfigModal={setshowConfigModal}
          />
        )}
        {openSupportVideo && (
          <ModalWrapper>
            <SupportVideo
              onClose={() => {
                setOpenSupportVideo(false);
              }}
            />
          </ModalWrapper>
        )}
      </div>
      <div className="mob overlay" onClick={addvalue}></div>
    </>
  );
}

export default SideNav;

const OmniengageLogo = () => {
  return (
    <svg
      width="54"
      height="54"
      viewBox="0 0 68 68"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M45.3741 30.4054C47.512 29.4679 50.0516 30.4409 50.5457 32.7226C51.2867 36.1448 51.1705 39.7205 50.176 43.1238C48.7834 47.8892 45.7576 52.0123 41.6292 54.7701C37.5008 57.5279 32.5334 58.7443 27.5979 58.206C22.6624 57.6677 18.0739 55.4091 14.6371 51.8262C11.2003 48.2433 9.13443 43.5649 8.80187 38.6113C8.46931 33.6577 9.89124 28.7451 12.8183 24.735C15.7454 20.7248 19.9908 17.8732 24.81 16.68C28.2517 15.8279 31.8292 15.8605 35.2176 16.7432C37.4767 17.3317 38.3433 19.9096 37.3177 22.0067V22.0067C36.292 24.1038 33.7439 24.891 31.4266 24.6081C29.9056 24.4223 28.3519 24.5123 26.8418 24.8862C23.9502 25.6021 21.403 27.3131 19.6468 29.7192C17.8905 32.1253 17.0373 35.0728 17.2369 38.045C17.4364 41.0171 18.6759 43.8242 20.738 45.9739C22.8001 48.1237 25.5532 49.4788 28.5145 49.8018C31.4758 50.1248 34.4563 49.3949 36.9333 47.7403C39.4103 46.0856 41.2258 43.6118 42.0613 40.7525C42.4977 39.2592 42.6523 37.7107 42.5299 36.1832C42.3436 33.8562 43.2361 31.3429 45.3741 30.4054V30.4054Z"
        fill="#FB5F66"
      ></path>
      <path
        d="M53.1185 23.6639C52.3799 24.2422 50.1861 23.4112 47.814 22.3194C45.9231 23.0419 44.7003 22.6322 47.2581 25.3863C49.1221 27.3934 43.7167 27.1529 40.5963 30.2732C36.5793 34.4384 38.3334 43.7882 33.3978 35.9912C31.538 33.0532 34.1797 42.0226 32.9266 42.3874C31.2648 42.6672 31.4684 40.6416 30.8727 35.8983C30.5888 33.6373 30.2527 35.6886 29.8491 38.1711C31.5761 42.301 31.0061 39.5987 29.7744 41.0952L29.4155 40.6893C29.1159 42.237 28.7841 43.3955 28.4158 43.0272C27.5652 42.1765 26.7057 37.7753 25.551 36.3197L25.3955 36.144C25.4479 36.1964 25.4997 36.2552 25.551 36.3197L29.4155 40.6893C29.5682 39.9008 29.7125 39.0113 29.8491 38.1711C29.3228 36.9127 28.5833 35.0199 27.5843 32.1807C26.5209 27.9698 33.7239 30.3348 36.6549 27.996C39.586 25.6572 40.7038 22.6146 40.2445 19.5203C40.3024 18.4608 44.2585 20.6829 47.814 22.3194C48.4192 22.0881 49.0928 21.7408 49.7329 21.1367C50.1888 20.7063 50.5495 20.2429 50.7828 19.7461L46.7626 13.0023C50.7998 15.6984 51.6303 17.9421 50.7828 19.7461L53.1185 23.6639Z"
        fill="#444444"
      ></path>
      <circle
        cx="47.0261"
        cy="20.4576"
        r="7.51467"
        transform="rotate(-135 47.0261 20.4576)"
        fill="#444444"
      ></circle>
      <circle
        cx="30.155"
        cy="37.3282"
        r="9.0176"
        transform="rotate(-135 30.155 37.3282)"
        fill="#444444"
      ></circle>
    </svg>
  );
};

export const HomeIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        opacity="0.4"
        d="M9.07861 16.1354H14.8936"
        stroke="#444444"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.3999 13.713C2.3999 8.082 3.0139 8.475 6.3189 5.41C7.7649 4.246 10.0149 2 11.9579 2C13.8999 2 16.1949 4.235 17.6539 5.41C20.9589 8.475 21.5719 8.082 21.5719 13.713C21.5719 22 19.6129 22 11.9859 22C4.3589 22 2.3999 22 2.3999 13.713Z"
        stroke="#444444"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const IntegrationIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="26"
      height="24"
      viewBox="0 0 26 24"
      fill="none"
    >
      <path
        opacity="0.4"
        d="M17.5946 10.1516C17.5946 9.63563 17.1746 9.20363 16.6586 9.20363H15.8666V6.79163C15.8666 6.27563 15.4466 5.84363 14.9306 5.84363C14.4146 5.84363 13.9946 6.26363 13.9946 6.79163V9.20363H12.1226V6.79163C12.1226 6.27563 11.7026 5.84363 11.1866 5.84363C10.6706 5.84363 10.2506 6.26363 10.2506 6.79163V9.20363H9.41061C8.89461 9.20363 8.47461 9.62363 8.47461 10.1516V12.5876C8.47461 14.7956 10.0226 16.6436 12.0866 17.0876C12.6506 17.1956 13.2746 17.1956 13.9586 17.0876C16.0466 16.6556 17.6186 14.7956 17.6186 12.5756V10.1396L17.5946 10.1516ZM15.7226 12.5876C15.7226 14.0876 14.5106 15.2996 13.0226 15.2996C11.5346 15.2996 10.3226 14.0876 10.3226 12.5876V11.0996H15.7106V12.5876H15.7226Z"
        fill="#444444"
      />
      <path
        d="M21.482 3.54C19.214 1.26 16.202 0 12.998 0C9.79405 0 6.78205 1.26 4.51405 3.54C2.24605 5.82 0.998047 8.904 0.998047 12.132C0.998047 14.928 1.97005 17.628 3.72205 19.788C5.46205 21.912 7.88605 23.388 10.538 23.94C10.73 23.976 10.922 24 11.114 24C11.75 24 12.374 23.784 12.89 23.364C13.55 22.824 13.922 22.02 13.922 21.168V18.48H12.05V21.168C12.05 21.564 11.834 21.792 11.702 21.9C11.486 22.08 11.198 22.152 10.91 22.092C6.24205 21.12 2.85805 16.932 2.85805 12.132C2.87005 6.504 7.41805 1.884 12.998 1.884C18.578 1.884 23.1261 6.456 23.1261 12.072C23.1261 16.188 20.702 19.896 16.946 21.492C16.466 21.696 16.25 22.248 16.454 22.728C16.658 23.208 17.21 23.436 17.678 23.232C19.826 22.32 21.65 20.796 22.958 18.84C24.302 16.836 25.01 14.496 25.01 12.072C25.01 8.844 23.7621 5.808 21.494 3.528L21.482 3.54Z"
        fill="#444444"
      />
    </svg>
  );
};
export const TemplatesIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1 12C1 3.74933 1.03614 1 5.5 1C9.96386 1 10 3.74933 10 12C10 20.2507 10.0142 23 5.5 23C0.985763 23 1 20.2507 1 12Z"
        stroke="#444444"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        opacity="0.5"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14 5.5C14 2.12473 14.0361 1 18.5 1C22.9639 1 23 2.12473 23 5.5C23 8.87527 23.0142 10 18.5 10C13.9858 10 14 8.87527 14 5.5Z"
        stroke="#444444"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14 18.5C14 15.1247 14.0361 14 18.5 14C22.9639 14 23 15.1247 23 18.5C23 21.8753 23.0142 23 18.5 23C13.9858 23 14 21.8753 14 18.5Z"
        stroke="#444444"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const AnalyticsIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.8631 14.0955C18.6126 14.0955 19.2417 14.7141 19.1271 15.4543C18.4548 19.8089 14.7269 23.0421 10.2308 23.0421C5.25648 23.0421 1.22461 19.0102 1.22461 14.037C1.22461 9.93967 4.33738 6.12296 7.84188 5.25999C8.59493 5.07406 9.36669 5.60377 9.36669 6.37904C9.36669 11.6317 9.54326 12.9905 10.5407 13.7295C11.5381 14.4685 12.711 14.0955 17.8631 14.0955Z"
        stroke="#444444"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        opacity="0.4"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22.7669 9.72209C22.8265 6.34739 18.6812 0.907644 13.6297 1.00119C13.2368 1.00821 12.9223 1.33562 12.9047 1.72735C12.7773 4.50218 12.9491 8.09789 13.045 9.72794C13.0743 10.2354 13.473 10.6342 13.9793 10.6634C15.655 10.7593 19.3817 10.8903 22.1167 10.4763C22.4886 10.4202 22.761 10.0975 22.7669 9.72209Z"
        stroke="#444444"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const ChatsIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.0714 19.0699C16.0152 22.1263 11.4898 22.7867 7.78642 21.074C7.23971 20.8539 6.79148 20.676 6.36537 20.676C5.17849 20.683 3.70117 21.8339 2.93336 21.067C2.16555 20.2991 3.31726 18.8206 3.31726 17.6266C3.31726 17.2004 3.14642 16.7602 2.92632 16.2124C1.21283 12.5096 1.87411 7.98269 4.93026 4.92721C8.8316 1.02443 15.17 1.02443 19.0714 4.9262C22.9797 8.83501 22.9727 15.1681 19.0714 19.0699Z"
        stroke="#444444"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        opacity="0.4"
        d="M15.9389 12.4121H15.9479"
        stroke="#444444"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        opacity="0.4"
        d="M11.931 12.4121H11.94"
        stroke="#444444"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        opacity="0.4"
        d="M7.92128 12.4121H7.93028"
        stroke="#444444"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const AudienceIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.592 15.207C13.281 15.207 16.434 15.766 16.434 17.999C16.434 20.232 13.302 20.807 9.592 20.807C5.902 20.807 2.75 20.253 2.75 18.019C2.75 15.785 5.881 15.207 9.592 15.207Z"
        stroke="#444444"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.59108 12.02C7.16908 12.02 5.20508 10.057 5.20508 7.635C5.20508 5.213 7.16908 3.25 9.59108 3.25C12.0121 3.25 13.9761 5.213 13.9761 7.635C13.9851 10.048 12.0351 12.011 9.62208 12.02H9.59108Z"
        stroke="#444444"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        opacity="0.4"
        d="M16.4844 10.8813C18.0854 10.6563 19.3184 9.28228 19.3214 7.61928C19.3214 5.98028 18.1264 4.62028 16.5594 4.36328"
        stroke="#444444"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        opacity="0.4"
        d="M18.5957 14.7305C20.1467 14.9615 21.2297 15.5055 21.2297 16.6255C21.2297 17.3965 20.7197 17.8965 19.8957 18.2095"
        stroke="#444444"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const SettingsIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.8064 7.62358L20.184 6.54349C19.6574 5.62957 18.4905 5.31429 17.5753 5.83869V5.83869C17.1397 6.09531 16.6198 6.16812 16.1305 6.04106C15.6411 5.91399 15.2224 5.59749 14.9666 5.16134C14.8021 4.88412 14.7137 4.56836 14.7103 4.24601V4.24601C14.7251 3.72919 14.5302 3.22837 14.1698 2.85764C13.8094 2.48691 13.3143 2.27783 12.7973 2.27805H11.5433C11.0367 2.27804 10.5511 2.47988 10.1938 2.83891C9.83644 3.19795 9.63693 3.68456 9.63937 4.19109V4.19109C9.62435 5.23689 8.77224 6.07678 7.72632 6.07667C7.40397 6.07332 7.08821 5.98491 6.81099 5.82038V5.82038C5.89582 5.29598 4.72887 5.61126 4.20229 6.52519L3.5341 7.62358C3.00817 8.53636 3.31916 9.70258 4.22975 10.2323V10.2323C4.82166 10.574 5.18629 11.2056 5.18629 11.889C5.18629 12.5725 4.82166 13.204 4.22975 13.5458V13.5458C3.32031 14.0719 3.00898 15.2353 3.5341 16.1453V16.1453L4.16568 17.2346C4.4124 17.6798 4.82636 18.0083 5.31595 18.1474C5.80554 18.2866 6.3304 18.2249 6.77438 17.976V17.976C7.21084 17.7213 7.73094 17.6515 8.2191 17.7822C8.70725 17.9128 9.12299 18.233 9.37392 18.6716C9.53845 18.9489 9.62686 19.2646 9.63021 19.587V19.587C9.63021 20.6435 10.4867 21.5 11.5433 21.5H12.7973C13.8502 21.5 14.7053 20.6491 14.7103 19.5961V19.5961C14.7079 19.088 14.9086 18.6 15.2679 18.2407C15.6272 17.8814 16.1152 17.6806 16.6233 17.6831C16.9449 17.6917 17.2594 17.7797 17.5387 17.9394V17.9394C18.4515 18.4653 19.6177 18.1543 20.1474 17.2437V17.2437L20.8064 16.1453C21.0615 15.7075 21.1315 15.186 21.001 14.6963C20.8704 14.2067 20.55 13.7893 20.1108 13.5366V13.5366C19.6715 13.2839 19.3511 12.8665 19.2206 12.3769C19.09 11.8873 19.16 11.3658 19.4151 10.9279C19.581 10.6383 19.8211 10.3982 20.1108 10.2323V10.2323C21.0159 9.70286 21.3262 8.54346 20.8064 7.63274V7.63274V7.62358Z"
        stroke="#444444"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle
        opacity="0.4"
        cx="12.1747"
        cy="11.889"
        r="2.63616"
        stroke="#444444"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const PricingIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
  >
    <mask id="path-1-inside-1_9377_52137" fill="white">
      <path d="M12 2C6.48625 2 2 6.48625 2 12C2 17.5138 6.48625 22 12 22C17.5138 22 22 17.5138 22 12C22 6.48625 17.5138 2 12 2ZM12 20.75C7.175 20.75 3.25 16.825 3.25 12C3.25 7.175 7.175 3.25 12 3.25C16.825 3.25 20.75 7.175 20.75 12C20.75 16.825 16.825 20.75 12 20.75Z" />
    </mask>
    <path
      d="M12 2V0.5C5.65782 0.5 0.5 5.65782 0.5 12H2H3.5C3.5 7.31468 7.31468 3.5 12 3.5V2ZM2 12H0.5C0.5 18.3422 5.65782 23.5 12 23.5V22V20.5C7.31468 20.5 3.5 16.6853 3.5 12H2ZM12 22V23.5C18.3422 23.5 23.5 18.3422 23.5 12H22H20.5C20.5 16.6853 16.6853 20.5 12 20.5V22ZM22 12H23.5C23.5 5.65782 18.3422 0.5 12 0.5V2V3.5C16.6853 3.5 20.5 7.31468 20.5 12H22ZM12 20.75V19.25C8.00343 19.25 4.75 15.9966 4.75 12H3.25H1.75C1.75 17.6534 6.34657 22.25 12 22.25V20.75ZM3.25 12H4.75C4.75 8.00343 8.00343 4.75 12 4.75V3.25V1.75C6.34657 1.75 1.75 6.34657 1.75 12H3.25ZM12 3.25V4.75C15.9966 4.75 19.25 8.00343 19.25 12H20.75H22.25C22.25 6.34657 17.6534 1.75 12 1.75V3.25ZM20.75 12H19.25C19.25 15.9966 15.9966 19.25 12 19.25V20.75V22.25C17.6534 22.25 22.25 17.6534 22.25 12H20.75Z"
      fill="#444444"
      mask="url(#path-1-inside-1_9377_52137)"
    />
    <path
      d="M12 11.375C10.9837 11.375 10.125 10.8025 10.125 10.125C10.125 9.4475 10.9837 8.875 12 8.875C12.575 8.875 13.1075 9.055 13.46 9.3675C13.5213 9.42213 13.5928 9.46412 13.6704 9.49105C13.748 9.51799 13.8302 9.52934 13.9121 9.52446C13.9941 9.51958 14.0744 9.49857 14.1482 9.46263C14.2221 9.42668 14.2881 9.37652 14.3425 9.315C14.5725 9.0575 14.5487 8.6625 14.29 8.4325C13.8525 8.04375 13.265 7.78125 12.625 7.6775V7C12.625 6.655 12.345 6.375 12 6.375C11.655 6.375 11.375 6.655 11.375 7V7.675C9.95 7.9075 8.875 8.9175 8.875 10.125C8.875 11.5037 10.2775 12.625 12 12.625C13.0163 12.625 13.875 13.1975 13.875 13.875C13.875 14.5525 13.0163 15.125 12 15.125C11.425 15.125 10.8925 14.945 10.54 14.6325C10.2825 14.4025 9.8875 14.425 9.6575 14.685C9.4275 14.9425 9.45125 15.3375 9.71 15.5675C10.1475 15.9575 10.735 16.2188 11.375 16.3237V17C11.375 17.345 11.655 17.625 12 17.625C12.345 17.625 12.625 17.345 12.625 17V16.325C14.05 16.0925 15.125 15.0825 15.125 13.875C15.125 12.4963 13.7225 11.375 12 11.375Z"
      fill="#444444"
    />
  </svg>
);
export const SupportIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M12 2C6.47301 2 2 6.4725 2 12C2 17.5269 6.4725 22 12 22C17.527 22 22 17.5275 22 12C22 6.47301 17.5275 2 12 2ZM12 20.6046C7.25539 20.6046 3.39535 16.7446 3.39535 12C3.39535 7.25535 7.25539 3.39535 12 3.39535C16.7446 3.39535 20.6046 7.25535 20.6046 12C20.6046 16.7446 16.7446 20.6046 12 20.6046Z"
      fill="#444444"
    />
    <path
      d="M11.7033 14.6535C11.1504 14.6535 10.7029 15.1142 10.7029 15.667C10.7029 16.2068 11.1373 16.6806 11.7033 16.6806C12.2693 16.6806 12.7168 16.2068 12.7168 15.667C12.7168 15.1142 12.2561 14.6535 11.7033 14.6535ZM11.8744 6.97949C10.0973 6.97949 9.28125 8.03258 9.28125 8.74336C9.28125 9.25672 9.71563 9.49367 10.071 9.49367C10.7818 9.49367 10.4923 8.48008 11.8349 8.48008C12.493 8.48008 13.0196 8.76969 13.0196 9.3752C13.0196 10.086 12.2824 10.494 11.848 10.8626C11.4663 11.1916 10.9661 11.7313 10.9661 12.8634C10.9661 13.5478 11.1504 13.7453 11.6901 13.7453C12.335 13.7453 12.4667 13.4557 12.4667 13.2055C12.4667 12.5211 12.4798 12.1262 13.2038 11.5602C13.5592 11.2838 14.678 10.3887 14.678 9.15137C14.678 7.91406 13.5592 6.97949 11.8744 6.97949Z"
      fill="#444444"
    />
  </svg>
);

const LockSvg = () => {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="21.6667" height="22" rx="10.8333" fill="#FB5F66" />
      <path
        d="M14.9167 8.914V8.08333C14.9167 7.00037 14.4865 5.96175 13.7207 5.19598C12.9549 4.43021 11.9163 4 10.8333 4C9.75037 4 8.71175 4.43021 7.94598 5.19598C7.18021 5.96175 6.75 7.00037 6.75 8.08333V8.914C6.23046 9.14074 5.78825 9.51397 5.47746 9.98804C5.16666 10.4621 5.00075 11.0165 5 11.5833V15.0833C5.00093 15.8566 5.30851 16.5979 5.8553 17.1447C6.40208 17.6915 7.1434 17.9991 7.91667 18H13.75C14.5233 17.9991 15.2646 17.6915 15.8114 17.1447C16.3582 16.5979 16.6657 15.8566 16.6667 15.0833V11.5833C16.6659 11.0165 16.5 10.4621 16.1892 9.98804C15.8784 9.51397 15.4362 9.14074 14.9167 8.914ZM7.91667 8.08333C7.91667 7.30979 8.22396 6.56792 8.77094 6.02094C9.31792 5.47396 10.0598 5.16667 10.8333 5.16667C11.6069 5.16667 12.3487 5.47396 12.8957 6.02094C13.4427 6.56792 13.75 7.30979 13.75 8.08333V8.66667H7.91667V8.08333ZM15.5 15.0833C15.5 15.5475 15.3156 15.9926 14.9874 16.3208C14.6592 16.649 14.2141 16.8333 13.75 16.8333H7.91667C7.45254 16.8333 7.00742 16.649 6.67923 16.3208C6.35104 15.9926 6.16667 15.5475 6.16667 15.0833V11.5833C6.16667 11.1192 6.35104 10.6741 6.67923 10.3459C7.00742 10.0177 7.45254 9.83333 7.91667 9.83333H13.75C14.2141 9.83333 14.6592 10.0177 14.9874 10.3459C15.3156 10.6741 15.5 11.1192 15.5 11.5833V15.0833Z"
        fill="white"
      />
      <path
        d="M10.8353 11C10.548 11 10.2724 11.0966 10.0693 11.2685C9.86609 11.4404 9.75195 11.6736 9.75195 11.9167V13.75C9.75195 13.9931 9.86609 14.2263 10.0693 14.3982C10.2724 14.5701 10.548 14.6667 10.8353 14.6667C11.1226 14.6667 11.3982 14.5701 11.6013 14.3982C11.8045 14.2263 11.9186 13.9931 11.9186 13.75V11.9167C11.9186 11.6736 11.8045 11.4404 11.6013 11.2685C11.3982 11.0966 11.1226 11 10.8353 11Z"
        fill="white"
      />
    </svg>
  );
};
export const SupportDocLinkIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    viewBox="0 0 16 16"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.33399 1.33301H4.00065C3.29341 1.33301 2.61513 1.61396 2.11503 2.11406C1.61494 2.61415 1.33398 3.29243 1.33398 3.99968V11.9997C1.33398 12.7069 1.61494 13.3852 2.11503 13.8853C2.61513 14.3854 3.29341 14.6663 4.00065 14.6663H12.0007C12.7079 14.6663 13.3862 14.3854 13.8863 13.8853C14.3864 13.3852 14.6673 12.7069 14.6673 11.9997V8.66634C14.6673 8.48953 14.5971 8.31996 14.4721 8.19494C14.347 8.06991 14.1775 7.99968 14.0007 7.99968C13.8238 7.99968 13.6543 8.06991 13.5292 8.19494C13.4042 8.31996 13.334 8.48953 13.334 8.66634V11.9997C13.334 12.3533 13.1935 12.6924 12.9435 12.9425C12.6934 13.1925 12.3543 13.333 12.0007 13.333H4.00065C3.64703 13.333 3.30789 13.1925 3.05784 12.9425C2.80779 12.6924 2.66732 12.3533 2.66732 11.9997V3.99968C2.66732 3.64605 2.80779 3.30691 3.05784 3.05687C3.30789 2.80682 3.64703 2.66634 4.00065 2.66634H7.33399C7.5108 2.66634 7.68037 2.5961 7.80539 2.47108C7.93041 2.34606 8.00065 2.17649 8.00065 1.99967C8.00065 1.82286 7.93041 1.65329 7.80539 1.52827C7.68037 1.40325 7.5108 1.33301 7.33399 1.33301ZM12.3913 2.66634H10.0007C9.82384 2.66634 9.65427 2.5961 9.52925 2.47108C9.40422 2.34606 9.33399 2.17649 9.33399 1.99967C9.33399 1.82286 9.40422 1.65329 9.52925 1.52827C9.65427 1.40325 9.82384 1.33301 10.0007 1.33301H14.0007C14.1775 1.33301 14.347 1.40325 14.4721 1.52827C14.5971 1.65329 14.6673 1.82286 14.6673 1.99967V5.99968C14.6673 6.17649 14.5971 6.34606 14.4721 6.47108C14.347 6.5961 14.1775 6.66634 14.0007 6.66634C13.8238 6.66634 13.6543 6.5961 13.5292 6.47108C13.4042 6.34606 13.334 6.17649 13.334 5.99968V3.60901L8.47199 8.47101C8.34625 8.59245 8.17785 8.65964 8.00305 8.65813C7.82825 8.65661 7.66105 8.58649 7.53744 8.46289C7.41383 8.33928 7.34372 8.17207 7.3422 7.99728C7.34068 7.82248 7.40788 7.65408 7.52932 7.52834L12.3913 2.66634Z"
      fill="white"
    />
  </svg>
);
